<template>
  <div class="nologoff">
    <div class="setlong_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
    </div>
    <div class="img">
      <img src="@/assets/mylogin/gantanhao-2 (1).png" alt="" />
    </div>
    <div class="prompt">
      <p>注销无法完成</p>
    </div>
    <p
      style="
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        width: 94%;
        margin: 42px auto;
      "
    >
      由于以下原因,暂时无法注销账号
    </p>
    <div class="tect">
      <p>1、{{ resultDesc }}</p>
    </div>
    <div style="margin: 10px 0 20px; width: 94%; margin: 20px auto">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="form_btn"
        to="my"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "nologoff",
  data() {
    return {
      resultDesc: "",
    };
  },
  methods: {
    to() {
      window.history.go(-1);
    },
  },
  mounted() {
    this.resultDesc = this.$route.query.resultDesc;
    console.log(this.resultDesc);
  },
};
</script>

<style lang="scss" scoped>
.nologoff {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .setlong_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    position: relative;
  }
  .img {
    width: 40px;
    height: 40px;
    margin: 29px auto;
    margin-bottom: 0px;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .prompt {
    width: 100%;
    margin: 0 auto;
    p {
      margin: 0 auto;
      width: 23%;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-top: 11px;
    }
  }
  .tect {
    width: 94%;
    height: 142px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 auto;
    padding: 0px 0px 0px 12px;
    overflow: hidden;
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-top: 5px;
    }
  }
}
</style>